import React, { useState } from 'react'
import axios from 'axios';
const MamamonteChecks = ({varVTSIndex,varMamamonteCheckList,GetMamamonteOptionsList}) => {

  const [varChecksInfo,setChecksInfo] = useState({});
  const [varShowSubChecks,setShowSubChecks] = useState(0);

  //추가/편집
  const onEditChecksHandler = (e,vtc_idx) => {
    e.preventDefault();
    if(vtc_idx === 0) {
      const newItem = {vtc_idx:0,vts_idx:varVTSIndex,vtc_index:"",vtc_code:'',vtc_checkpoiont:''};
      setChecksInfo(newItem);
    } else {
      const checksData = varMamamonteCheckList.find(el=>el.vtc_idx === vtc_idx);
      setChecksInfo(checksData);
    }
    setShowSubChecks(true);
  }

  //입력값 조정
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "vtc_index") {
      setChecksInfo({...varChecksInfo,[name]:Number(value)});
    } else {
      setChecksInfo({...varChecksInfo,[name]:value});
    }
  }

  //평가항목 사용유무
  const onToggleChecksHandler = async(e,vtc_idx,vtc_status) => {
    let sprompt = '선택된 평가항목을 삭제합니까?';
    if(vtc_status === 1) sprompt = "선택된 평가항목을 사용합니까?";
    if(!window.confirm(sprompt)) return false;

    const sendData = {vtc_idx:vtc_idx,vtc_status:vtc_status};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_toggle_mamamonte_checks_status`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetMamamonteOptionsList();
      } else {
        alert(res.data.message);
      }
    });   
  }
  
  //평가항목 저장
  const onUpdateChecksHandler = async(e)  => {
    const sendData = {dataInfo:varChecksInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_mamamonte_checks_status`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetMamamonteOptionsList();
      } else {
        alert(res.data.message);
      }
    });   
  }

  return (
    <div>
      <div className="main-box">
        <div className="btn-right">
          <button className="btn-danger" onClick={e=>onEditChecksHandler(e,0)}>추가</button>
        </div>
        <table cellPadding="5" cellSpacing="0" border="1" className="write">
          <colgroup><col width="10%"/><col width="10%"/><col width="50%"/><col width="10%"/><col width="20%"/></colgroup>
          <thead>
            <tr><th>순서</th><th>코드</th><th>점검항목</th><th>사용유무</th><th>관리</th></tr>
          </thead>
          <tbody>
            {varMamamonteCheckList.map((checks,i) => (
              <tr key={'checks_'+i}>
                <td>{checks.vtc_index}</td>
                <td>{checks.vtc_code}</td>
                <td>{checks.vtc_checkpoint}</td>
                <td>{checks.vtc_status===1?"사용":"사용중지"}</td>
                <td>
                  <button onClick={e=>onEditChecksHandler(e,checks.vtc_idx)} style={{width:"70px"}} className="btn line black">편집</button>
                  {checks.vtc_status===1?
                    <button onClick={e=>onToggleChecksHandler(e,checks.vtc_idx,0)} style={{width:"90px"}} className="btn line black">사용중지</button>
                  :
                    <button onClick={e=>onToggleChecksHandler(e,checks.vtc_idx,1)} style={{width:"70px"}} className="btn line black">사용</button>
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={varShowSubChecks?{display:"",marginTop:"10px"}:{display:"none"}}>
        <div className="main-box" >
          <table cellPadding="5" cellSpacing="0" border="1" className="write">
            <colgroup><col width="30%"/><col width="70%"/></colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>평가순서</th>
                <td><input type="text" className="w_s_input" name="vts_index" value={varChecksInfo.vtc_index||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
              </tr>
              <tr>
                <th>평가코드</th>
                <td><input type="text" className="w_s_input" name="vtc_code" value={varChecksInfo.vtc_code||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
              </tr>
              <tr>
                <th>평가항목</th>
                <td><input type="text" className="w_s_input" name="vtc_checkpoint" value={varChecksInfo.vtc_checkpoint||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn-center" style={{marginBottom:"20px"}}>
          <button onClick={(e)=>onUpdateChecksHandler(e)} style={{width:"90px"}} className="btn">저장</button>
          <button onClick={()=>setShowSubChecks(false)} style={{width:"90px"}} className="btn line">닫기</button>
        </div>
      </div>
    </div>
  )
}
export default MamamonteChecks;